<template>
  <div class="submit-form">
  <h4>Nova comunicação de perdas</h4>
    <div v-if="!submitted">
      <div class="form-group">
        <label for="name">Nome do produtor rural</label>
        <input
          type="text"
          class="form-control"
          id="name_farmer"
          required
          v-model="report.name_farmer"
          name="name_farmer"
        />
      </div>

      <div class="form-group">
        <div id="app">
        
          <label class="control-label requiredField" for="email">
            E-mail do produtor rural
          </label>
    
           <input class="form-control" @change="isEmailValid" v-model="report.email_farmer" required type="email" id="email_farmer" />
    
            <span class="badge badge-danger" v-show="wrongEmail" >Endereço de e-mail incorreto</span>
   
        </div>
      </div>

      <div class="form-group">
        <label for="cpf_farmer">CPF do produtor rural</label>
        <input
          @change="isCPFValid"
          type="text"
          v-mask="'###.###.###-##'"
          class="form-control"
          id="cpf_farmer"
          required
          v-model="report.cpf_farmer"
          name="cpf_farmer"
        />
        <span class="badge badge-danger" v-show="wrongCPF" >CPF incorreto</span>
      </div>

      <div class="form-group">
        <label for="loc_titllage_lat">Localização da lavoura | Latitude</label>
        <input
          type="text"
          class="form-control"
          id="loc_titllage_lat"
          required
          v-model="report.loc_titllage_lat"
          name="loc_titllage_lat"
        />
      </div>

      <div class="form-group">
        <label for="loc_tittlage_lon">Localização da lavoura | Longitude</label>
        <input
          type="text"
          class="form-control"
          id="loc_tittlage_lon"
          required
          v-model="report.loc_tittlage_lon"
          name="loc_tittlage_lon"
        />
      </div>

      <div class="form-group">
      <label for="event_date">Lavoura</label>
      <br />
        <select id="type_tillage" required class="form_control" v-model="report.type_tillage">
          <option value="" disabled selected>Selecione</option>
          <option value="MI">MILHO</option>
          <option value="SO">SOJA</option>
          <option value="TR">TRIGO</option>
          <option value="FE">FEIJÃO</option>
        </select>
      </div>

       <div class="form-group">
        <label for="harvest_date">Data da colheita</label>
        <input
          type="date"
          class="form-control"
          id="harvest_date"
          required
          v-model="report.harvest_date"
          name="harvest_date"
        />
      </div>

      <div class="form-group">
        <label for="event_date">Data do evento</label>
        <input
          type="date"
          class="form-control"
          id="event_date"
          required
          v-model="report.event_date"
          name="event_date"
        />
      </div>

      <div class="form-group">
        <label for="event">Evento ocorrido</label>
      <br />
        <select id="event" class="form_control" v-model="report.event">
          <option value="" disabled selected>Selecione</option>
          <option value="CE">CHUVA EXCESSIVA</option>
          <option value="GE">GEADA</option>
          <option value="GR">GRANIZO</option>
          <option value="SE">SECA</option>
          <option value="VE">VENDAVAL</option>
          <option value="RA">RAIO</option>
        </select>
      </div>

        <div v-show="!pendente" class="msg">
          <span v-if="valido"> </span>
          <span v-else  class="badge badge-danger"> CPF ou E-mail não é valido, tente novamente </span>
        </div>
      <button @click="verificarForm" class="btn btn-success">Cadastrar</button>

    </div>


    <div v-else>
      <p>{{ info.res }}</p>
      <button class="btn btn-success" @click="newReport">Cadastrar nova comunicação de perda</button>
      <br />
      <br />
      <router-link to="/reports" class="badge badge-dark">Lista de comunicações</router-link>
    </div>
  </div>
</template>

<script>
import ReportDataService from "../services/ReportDataService";
import {mask} from 'vue-the-mask';

export default {
  directives: {mask},
  name: "add-report",
  data() {
    return {
      report: {
        name_farmer: "",
        email_farmer: "",
        cpf_farmer: null,
        loc_titllage_lat: "",
        loc_tittlage_lon: "",
        type_tillage: "",
        harvest_date: "",
        event_date: "",
        event: ""
      },
      submitted: false,
      pendente: true,
      valido: false,
      wrongEmail: false,
      wrongCPF: false
    };
  },
  methods: {
    verificarForm() {
      this.valido = validar(this.report.cpf_farmer);      
      if (this.wrongEmail === false && this.wrongCPF === false){
        this.saveReport();
      } else {
        this.pendente = false;

      }
    },

    saveReport() {
      var data = {
        name_farmer: this.report.name_farmer,
        email_farmer: this.report.email_farmer,
        cpf_farmer: this.report.cpf_farmer,
        loc_titllage_lat: this.report.loc_titllage_lat,
        loc_tittlage_lon: this.report.loc_tittlage_lon,
        type_tillage: this.report.type_tillage,
        harvest_date: this.report.harvest_date,
        event_date: this.report.event_date,
        event: this.report.event,
      };

      ReportDataService.create(data)
        .then(response => {
          this.report.id = response.data.id;
          this.info = response.data;
          console.log(response.data);

          this.submitted = true;
        })
        .catch(e => {
          console.log(e);
        });
    },
    
    newReport() {
      this.submitted = false;
      this.report = {};
    },

    isCPFValid() {
      this.valido = validar(this.report.cpf_farmer);      
      if (this.valido === true){
        this.wrongCPF = false;
      } else {
        this.wrongCPF = true;

      }
    },

    isEmailValid() {
      if (emailRe.test(this.report.email_farmer)) {
        this.wrongEmail = false;
      } else {
        this.wrongEmail = true;
      }
    }
  }
};

const validar = cpf_farmer => checkAll(prepare(cpf_farmer))

const notDig = i => !['.', '-', ' '].includes(i)
const prepare = cpf_farmer => cpf_farmer.trim().split('').filter(notDig).map(Number)
const is11Len = cpf_farmer => cpf_farmer.length === 11
const notAllEquals = cpf_farmer => !cpf_farmer.every(i => cpf_farmer[0] === i)
const onlyNum = cpf_farmer => cpf_farmer.every(i => !isNaN(i))

const calcDig = limit => (a, i, idx) => a + i * ((limit + 1) - idx)
const somaDig = (cpf_farmer, limit) => cpf_farmer.slice(0, limit).reduce(calcDig(limit), 0)
const resto11 = somaDig => 11 - (somaDig % 11)
const zero1011 = resto11 => [10, 11].includes(resto11) ? 0 : resto11

const getDV = (cpf_farmer, limit) => zero1011(resto11(somaDig(cpf_farmer, limit)))
const verDig = pos => cpf_farmer => getDV(cpf_farmer, pos) === cpf_farmer[pos]

const checks = [is11Len, notAllEquals, onlyNum, verDig(9), verDig(10)]
const checkAll = cpf_farmer => checks.map(f => f(cpf_farmer)).every(r => !!r)

/* eslint-disable no-useless-escape */
const emailRe = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


</script>

<style>
.submit-form {
  max-width: 500px;
  margin: auto;
}
</style>
